import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cd605cfa"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "detail" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { class: "brand" }, "ブランド"),
        /*#__PURE__*/ _createElementVNode("th", { class: "store" }, "付与店舗"),
        /*#__PURE__*/ _createElementVNode("th", { class: "point_name" }, "ポイント名"),
        /*#__PURE__*/ _createElementVNode("th", { class: "point_grant_reason" }, "詳細説明"),
        /*#__PURE__*/ _createElementVNode("th", { class: "points" }, "付与ポイント数"),
        /*#__PURE__*/ _createElementVNode("th", { class: "effective_period_date" }, "有効期限"),
        /*#__PURE__*/ _createElementVNode("th", { class: "publisher" }, "発行者")
    ])
], -1));
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { class: "brand" };
const _hoisted_5 = { class: "store" };
const _hoisted_6 = { class: "point_name" };
const _hoisted_7 = { class: "point_grant_reason" };
const _hoisted_8 = { class: "points" };
const _hoisted_9 = { class: "effective_period_date" };
const _hoisted_10 = { class: "publisher" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", null, [
            _hoisted_2,
            ($data.itemState)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_3, [
                    _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_4, _toDisplayString($data.itemState.brand), 1),
                        _createElementVNode("td", _hoisted_5, _toDisplayString($data.itemState.store), 1),
                        _createElementVNode("td", _hoisted_6, _toDisplayString($data.itemState.point_name), 1),
                        _createElementVNode("td", _hoisted_7, _toDisplayString($data.itemState.point_grant_reason), 1),
                        _createElementVNode("td", _hoisted_8, _toDisplayString($data.itemState.points), 1),
                        _createElementVNode("td", _hoisted_9, _toDisplayString($data.itemState.effective_period_date) + "日 ", 1),
                        _createElementVNode("td", _hoisted_10, _toDisplayString($data.itemState.publisher), 1)
                    ])
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
